import { Button, CircularProgress, IconButton, Tooltip } from "@mui/material";
import FileUploadOutlinedIcon from "@mui/icons-material/FileUploadOutlined";

export function SpecsImageUploadTrigger({
  onUpload,
  uploading,
  accept = "image/png,image/jpeg,image/webp,image/svg+xml",
  title = "Upload image",
  buttonLabel = "Upload image",
  variant = "button",
  fullWidth = false,
  onOpenFilePicker,
}: {
  onUpload: (file: File) => void | Promise<void>;
  uploading: boolean;
  accept?: string;
  title?: string;
  buttonLabel?: string;
  variant?: "icon" | "button";
  fullWidth?: boolean;
  onOpenFilePicker?: () => void;
}) {
  if (uploading) {
    return variant === "icon" ? (
      <CircularProgress size={14} />
    ) : (
      <Button
        variant="outlined"
        size="small"
        disabled
        fullWidth={fullWidth}
        sx={{ textTransform: "none" }}
      >
        Uploading...
      </Button>
    );
  }

  const input = (
    <input
      type="file"
      accept={accept}
      hidden
      onChange={(event) => {
        const file = event.target.files?.[0];
        if (file) {
          void onUpload(file);
        }
        event.target.value = "";
      }}
    />
  );

  if (variant === "icon") {
    return (
      <Tooltip title={title}>
        <IconButton
          component="label"
          size="small"
          edge="end"
          sx={{ p: 0.25 }}
          onMouseDown={(event) => {
            onOpenFilePicker?.();
            event.preventDefault();
          }}
        >
          <FileUploadOutlinedIcon sx={{ fontSize: 16 }} />
          {input}
        </IconButton>
      </Tooltip>
    );
  }

  return (
    <Button
      component="label"
      size="small"
      variant="outlined"
      fullWidth={fullWidth}
      sx={{ textTransform: "none" }}
      onMouseDown={() => onOpenFilePicker?.()}
    >
      {buttonLabel}
      {input}
    </Button>
  );
}
